import Axios, { AxiosRequestConfig } from "axios";
import Resource from "./Resource";
import {
  User,
  Booking,
  Card,
  CardType,
  Event,
  Gift,
  Payment,
  Post,
  Store,
  ConfigItem,
  Coupon,
  Role,
  Product,
  Stock,
  StockLog,
  ProductCategory,
  Provider,
  Staff,
  Log
} from "./interfaces";

export const http = Axios.create({
  baseURL: process.env.VUE_APP_API_BASE
});

http.interceptors.request.use((request: AxiosRequestConfig) => {
  const token = window.localStorage.getItem("token");

  if (token) {
    request.headers["Authorization"] = token;
  }
  // stop request and return 401 response when no token exist except for login request
  if (
    !["auth/login", "config", "store", "wework/login"].includes(
      request.url || ""
    ) &&
    !window.localStorage.getItem("token")
  ) {
    console.log(
      "[Resource] Trying to request auth required api but no token, redirect to login."
    );
    window.location.href = "/login";
  }
  return request;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    // console.log("http.interceptors.response", err);
    const { response } = err;
    if (!response) return Promise.reject(err);
    // redirect to login page on any 401 response
    if (response.status === 401) {
      window.localStorage.removeItem("token");
      "[Resource] Server auth required, redirect to login.";
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const BookingResource = new Resource<Booking>(http, "booking/{id}");

export const BookingPriceResource = new Resource<Booking>(
  http,
  "booking-price"
);

export const CardResource = new Resource<Card>(http, "card/{id}");

export const CardTypeResource = new Resource<CardType>(http, "card-type/{id}");

export const CouponResource = new Resource<Coupon>(http, "coupon/{id}");

export const ConfigItemResource = new Resource<ConfigItem>(
  http,
  "config/{key}"
);

export const EventResource = new Resource<Event>(http, "event/{id}");

export const GiftResource = new Resource<Gift>(http, "gift/{id}");

export const LogResource = new Resource<Log>(http, "log/{id}");

export const PaymentResource = new Resource<Payment>(http, "payment/{id}");

export const PostResource = new Resource<Post>(http, "post/{id}");

export const ProductResource = new Resource<Product>(http, "product/{id}");

export const ProductCategoryResource = new Resource<ProductCategory>(
  http,
  "product-category/{id}"
);

export const ProviderResource = new Resource<Provider>(http, "provider/{id}");

export const RoleResource = new Resource<Role>(http, "role/{id}");

export const StaffResource = new Resource<Staff>(http, "staff/{id}");

export const StockResource = new Resource<Stock>(http, "stock/{id}");

export const StockLogResource = new Resource<StockLog>(http, "stock-log/{id}");

export const StoreResource = new Resource<Store>(http, "store/{id}");

export const UserResource = new Resource<User>(http, "user/{id}");
